import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pagination',
    standalone: false
})
export class PaginationPipe implements PipeTransform {
    transform(value: any[], page: number, itemsPerPage: number): any {
        if (!value) {
            return [];
        }
        return [...value.slice(itemsPerPage * (page - 1), itemsPerPage * page)];
    }
}
